module.exports = __webpack_public_path__ + "media/images/trail-6543b90520eee59eb5f0530aec955fcf.png";